import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import {
  ListDocumentRequestsRequest,
  DocumentRequest,
} from '@trustero/trustero-api-web/lib/request/request_pb'
import { DOCUMENT_REQUEST_STATUS_TO_LABEL } from 'src/pages/Requests/requests.constants'
import { prepareSearchableData } from 'src/Utils/search/search.helpers'
import { SearchableData } from 'src/Utils/search/search.types'
import { formatTimestamp } from 'src/Utils/formatDate'
import { DATE_FORMATS } from 'src/Utils/dateConstants'
import { useUsers } from 'src/components/async/Users'
import { getDRLFilterRequest } from './requests.helpers'

export const useDRLRequest = (): ListDocumentRequestsRequest => {
  const location = useLocation()

  return useMemo(() => getDRLFilterRequest(location.search), [location.search])
}

export const useSearchableRequests = (
  requests: DocumentRequest[],
): SearchableData<DocumentRequest>[] => {
  const { data: userResponse } = useUsers()
  const userMap = useMemo(() => {
    const map: Record<string, string> = {}
    const users = userResponse?.getUsersList() || []
    users.forEach((user) => {
      map[user.getId()] = user.getEmail()
    })
    return map
  }, [userResponse])

  const searchableRequest = useMemo(() => {
    return prepareSearchableData(
      requests,
      (request: DocumentRequest) => request.getId(),
      (request: DocumentRequest) => {
        const name = request.getRequest()
        const evidenceCount = request.getEvidenceCount().toString()
        const controlCount = request.getControlsCount().toString()
        const status = DOCUMENT_REQUEST_STATUS_TO_LABEL[request.getStatus()]
        const dueDate = request.getDueDate()
        const dueDateText = dueDate
          ? formatTimestamp(dueDate, DATE_FORMATS.VERBOSE)
          : ''
        const ownerId = request.getOwnerId()
        const ownerName = userMap[ownerId]

        return [
          name,
          evidenceCount,
          controlCount,
          status,
          dueDateText,
          ownerName,
        ]
      },
    )
  }, [requests, userMap])

  return searchableRequest
}
